import { ITASkiRentalReq } from '@/components/common/PlanYourTrip/types';
import { formatDateFromStr } from '@/util/formatDate';

export const getSkiRentalUrl = (baseUrl: string, query: ITASkiRentalReq) => {
  const urlParts = new URL(baseUrl);

  const urlSuffixParams: Record<string, string> = {
    startDate: formatDateFromStr(query.checkIn, 'yyyy-MM-dd'),
    endDate: formatDateFromStr(query.checkOut, 'yyyy-MM-dd'),
    adults: query.numAdults ? String(query.numAdults) : '',
    children: query.numChildren ? String(query.numChildren) : '',
    showDatePicker: '1',
  };

  Object.keys(urlSuffixParams).forEach((k) => {
    if (urlSuffixParams[k]) {
      urlParts.searchParams.set(k, urlSuffixParams[k]);
    }
  });

  for (let i = 0; i < (query.numChildren || 0); i += 1) {
    urlParts.searchParams.append('personAges[]', '7'); // 36 is magic value for children
  }

  for (let i = 0; i < (query.numAdults || 0); i += 1) {
    urlParts.searchParams.append('personAges[]', '36'); // 36 is magic value for adult
  }

  return urlParts.toString();
};

export default getSkiRentalUrl;
